import { useRouter } from 'next/router';
import { Divider } from '@/dashboard/mui';
import { JoveLogoGreen } from '@jove-frontend/uikit';
import { Box } from '@mui/material';
import DrawerMenuView from './components/DrawerMenu';
import PersonalCenterView from './components/PersonalCenter';
import UnreadNotificationView from './components/UnreadNotification';

const HeaderMobile = () => {
  const router = useRouter();

  /**
   * methods
   */

  const clickAction = () => {
    router.replace('/');
  };

  return (
    <>
      <Box className="flex flex-row flex-wrap items-center justify-between p-4 pr-0">
        <JoveLogoGreen className="h-[24px] w-[75px]" onClick={clickAction} />

        <Box className="flex flex-row items-center">
          <UnreadNotificationView className="mr-5" />
          <PersonalCenterView className="mr-2" />
          <DrawerMenuView className="mr-2" />
        </Box>
      </Box>
      <Divider />
    </>
  );
};

export default HeaderMobile;
